export let Loading = "admin/Loading";
export let Error = "admin/Error";
export let GetProducts = "getProducts";
export let GetUsers = "getUsers";
export let GetAdmins = "getAdmins";
export let AddProduct = "addProduct";
export let DelelteProduct = "deleteProduct";
export let EditProduct = "editProduct";
export let TotalProductsadd = "totalProducts";
export let TotalProductsless = "totalProducts";
export let TotalUsers = "totalUsers";
